import React from "react";
import { connect } from "react-redux";
import Card from "components/card";
import AnnouncementBoard from "./components/AnnouncementBoard";
import DashboardSummaryCard from "./components/DashboardSummaryCard";
import HyvidAwardWinners from "./components/HyvidAwardWinners";
import QuickDataEntry from "./components/QuickDataEntry";


const ManagementDashBoard = ({auth}) => {
    return (
        <Card className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-[28px] font-bold label-gradient emerald">
                        Management Portal
                    </h1>
                    <p className="text-[14px] tracking-normal mt-1 muted-text">
                        {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </div>
            </div>
            <div className="space-y-3">
                <AnnouncementBoard />
                <DashboardSummaryCard/>
                <HyvidAwardWinners/>
                <QuickDataEntry/>
            </div>
        </Card>
    )
};
const mapStateToProps = (state) => ({
    auth: state.auth,
    loading: state.auth.loading,
    error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
    
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagementDashBoard);